import PropertyCell from './property_cell';

export default PropertyCell;
